"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var custom_metrics_1 = require("@clientConstants/custom-metrics");
var angular_1 = __importDefault(require("angular"));
var lodash_1 = __importDefault(require("lodash"));
var string_math_1 = __importDefault(require("string-math"));
require("./custom-metrics.less");
var CustomMetricsModalController = /** @class */ (function () {
    function CustomMetricsModalController($scope, $filter, customMetricsService, PipedTextMenu, DynamicValueService, widgetManger, eventService, WIDGET_MANAGER_EVENTS, metricsService) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.customMetricsService = customMetricsService;
        $scope.$ctrl = this;
        this.translate = this.$filter('translate');
        this.pipedTextMenuItems = new PipedTextMenu().getCustomMetricsMenuItems();
        this.dynamicValueService = new DynamicValueService();
        this.widgetManager = widgetManger;
        this.eventService = eventService;
        this.WIDGET_MANAGER_EVENTS = WIDGET_MANAGER_EVENTS;
        this.notApplicableText = this.translate('NOT_APPLICABLE');
        this.customMetricPreview = this.notApplicableText;
        this.isEvaluating = false;
        this.CUSTOM_METRICS_LIMIT = 30;
        this.PIPED_TEXT_LIMIT = 10;
        this.customMetrics = this.customMetricsService.getCustomMetrics();
        this.metricsService = metricsService;
        this.CUSTOM_METRICS_ALLOWED_CHARACTERS = new Set([
            '0',
            '1',
            '2',
            '3',
            '4',
            '5',
            '6',
            '7',
            '8',
            '9',
            '(',
            ')',
            '+',
            '-',
            '/',
            '*',
            ' ',
            '.',
            'Enter'
        ]);
        if (this.customMetrics.length) {
            this.activeCustomMetric = this.customMetrics[0];
            this.computeCustomMetricPreview();
        }
    }
    CustomMetricsModalController.prototype.insertPipedTextItem = function (pipedText) {
        var ATTRIBUTES_TO_PICK = [
            'sourceId',
            'fieldId',
            'type',
            'attrName'
        ];
        var insert = function (str, toInsert, index) {
            return str.slice(0, index) + toInsert + str.slice(index, str.length);
        };
        var el = document.getElementById('custom-metrics-equation-textarea');
        var indexToInsert = el.selectionStart;
        var attributes = lodash_1.default.pick(pipedText.ptAttrs, ATTRIBUTES_TO_PICK);
        var uniqueIdentifier = lodash_1.default.join(Object.values(attributes), '/');
        var entry = "{" + uniqueIdentifier + "}";
        this.activeCustomMetric.equation = insert(this.activeCustomMetric.equation, entry, indexToInsert);
        var newValue = lodash_1.default.merge({ isCustomMetricPipedText: true }, pipedText);
        this.activeCustomMetric.values[entry] = newValue;
        this.computeCustomMetricPreview();
    };
    CustomMetricsModalController.prototype.isSelected = function (customMetric) {
        return customMetric.id === this.activeCustomMetric.id;
    };
    CustomMetricsModalController.prototype.isValid = function (customMetric) {
        return !!customMetric && this.validateEquation(customMetric);
    };
    CustomMetricsModalController.prototype.shouldShowErrorState = function (customMetric) {
        return !this.isSelected(customMetric) && !this.isValid(customMetric);
    };
    CustomMetricsModalController.prototype.hasInvalidCustomMetric = function () {
        var _this = this;
        return lodash_1.default.some(this.customMetrics, function (customMetric) {
            return !_this.isValid(customMetric);
        });
    };
    CustomMetricsModalController.prototype.hasCustomMetrics = function () {
        return this.customMetrics.length > 0;
    };
    CustomMetricsModalController.prototype.setActiveCustomMetric = function (customMetric) {
        this.activeCustomMetric = customMetric;
        this.computeCustomMetricPreview();
    };
    CustomMetricsModalController.prototype.createNewCustomMetric = function () {
        var newMetric = this.customMetricsService.getNewCustomMetric();
        return this.createMetric(newMetric);
    };
    CustomMetricsModalController.prototype.copyCustomMetric = function (customMetric) {
        var newMetric = this.customMetricsService.copyCustomMetric(customMetric);
        return this.createMetric(newMetric);
    };
    CustomMetricsModalController.prototype.deleteCustomMetric = function (customMetric) {
        lodash_1.default.remove(this.customMetrics, customMetric);
        this.metricsService.removeCustomMetric(customMetric.id);
        if (this.activeCustomMetric.id === customMetric.id && this.customMetrics.length > 0) {
            this.setActiveCustomMetric(this.customMetrics[0]);
        }
    };
    CustomMetricsModalController.prototype.save = function () {
        this.customMetricsService.saveCustomMetrics(this.customMetrics);
        this.metricsService.saveCustomMetrics(this.customMetrics);
        this.widgetManager.notifyAllWidgets(this.WIDGET_MANAGER_EVENTS.CUSTOM_METRICS_CHANGED);
        this.eventService.trigger(this.WIDGET_MANAGER_EVENTS.CUSTOM_METRICS_CHANGED);
    };
    /**
     * Validate the equation by regex-ing every piped text element and replacing it with 1.
     * Then, mathmatically evaluate it in a try-catch block to check for formatting errors.
     */
    CustomMetricsModalController.prototype.validateEquation = function (customMetric) {
        var equation = customMetric.equation;
        if (!equation || equation.length === 0) {
            return false;
        }
        var matches = lodash_1.default.uniq(equation.match(custom_metrics_1.CUSTOM_METRIC_REGEX)) || [];
        if (matches.length > this.PIPED_TEXT_LIMIT) {
            return false;
        }
        /**
         * Iterate through each match and verify that it is present in the custom metric object.
         * This prevents users from accidentally modifying the piped text.
         */
        var hasModifiedPipedText = lodash_1.default.some(matches, function (match) {
            return !customMetric.values[match];
        });
        if (hasModifiedPipedText) {
            return false;
        }
        /**
         * Replace each match with a random number with spacing around it.
         *
         * Replacement without whitespace could cause two elements without whitespace to
         * evaluate correctly, even when the equation is not formatted right.
         * eg: {a}{b} will return ' 1 1 ' instead of '11'.
         *
         * Additionally, random numbers should be used instead of 1
         * to prevent division by 0 evaluation errors (1 / (A - B))
         */
        var reducedEquation = lodash_1.default.reduce(matches, function (eq, match) {
            var rand = Math.random();
            var matchRegex = new RegExp(match, 'g');
            return eq.replace(matchRegex, " " + rand + " ");
        }, equation);
        try {
            string_math_1.default(reducedEquation);
            return true;
        }
        catch (e) {
            return false;
        }
    };
    CustomMetricsModalController.prototype.exceedsPipedTextLimit = function () {
        var matches = this.activeCustomMetric.equation.match(custom_metrics_1.CUSTOM_METRIC_REGEX) || [];
        return matches.length >= this.PIPED_TEXT_LIMIT;
    };
    CustomMetricsModalController.prototype.exceedsCustomMetricLimit = function () {
        return this.customMetrics.length >= this.CUSTOM_METRICS_LIMIT;
    };
    CustomMetricsModalController.prototype.validateKey = function (event) {
        if (!this.CUSTOM_METRICS_ALLOWED_CHARACTERS.has(event.key)) {
            event.preventDefault();
        }
    };
    CustomMetricsModalController.prototype.computeCustomMetricPreview = function () {
        var _this = this;
        var customMetric = this.activeCustomMetric;
        if (!this.validateEquation(customMetric)) {
            this.resetPreview();
            return;
        }
        // Set preview text to empty when spinner is shown
        this.customMetricPreview = '';
        this.isEvaluating = true;
        var ops = this.customMetricsService.getPipedTextAttributes(customMetric);
        // This must be done in a promise to have the angular modal act properly
        return this.dynamicValueService.fetchPipedTextValue(ops)
            .then(function (result) {
            var resolvedValue = _this.customMetricsService.resolveEquation(customMetric, result);
            _this.customMetricPreview = resolvedValue;
        })
            .finally(function () {
            _this.isEvaluating = false;
        });
    };
    CustomMetricsModalController.prototype.resetPreview = function () {
        this.isEvaluating = false;
        this.customMetricPreview = this.notApplicableText;
    };
    CustomMetricsModalController.prototype.createMetric = function (newMetric) {
        if (this.customMetrics.length >= this.CUSTOM_METRICS_LIMIT) {
            console.error("Can only create up to " + this.CUSTOM_METRICS_LIMIT + " custom metrics!");
            return;
        }
        this.customMetrics.unshift(newMetric);
        this.setActiveCustomMetric(newMetric);
    };
    CustomMetricsModalController.$inject = [
        '$scope',
        '$filter',
        'pr.customMetricsService',
        'prPipedTextMenuService',
        'prPipedTextDynamicValueService',
        'pr.widgetManager',
        'prEventService',
        'pr.WIDGET_MANAGER_EVENTS',
        'prMetricsService'
    ];
    return CustomMetricsModalController;
}());
(function (angularModule) {
    angularModule.controller('pr.customMetricsModalController', CustomMetricsModalController);
})(angular_1.default.module('qualtrics.pr'));
